import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  TableHead, TableRow, TableCell, TableSortLabel, Checkbox,
} from '@material-ui/core';

const styles = {
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
};

function Header({
  columns,
  orderBy,
  order,
  setOrderBy,
  extraColumn,
  onRowsSelect,
  onCheckedAll,
  checkedAll,
  data,
  selectableCondition,
}) {
  const [isCheck, setIsCheck] = useState(false);

  const hasSelectableRows = data?.some(row => selectableCondition?.(row));

  const handleSelectAllClick = (event) => {
    setIsCheck(!isCheck);
    onCheckedAll(!checkedAll);
    if (event.target.checked) {

      const validRows = selectableCondition
        ? data.filter(row => selectableCondition(row))
        : data;

      onRowsSelect(validRows);

    } else {
      onRowsSelect([]);
    }
  };

  return (
    <TableHead>
      <TableRow>
        {Boolean(onRowsSelect) && (
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={false}
              checked={isCheck}
              onChange={handleSelectAllClick}
              disabled={!hasSelectableRows}
            />
          </TableCell>
        )}
        {extraColumn && <TableCell padding="checkbox" />}
        {columns.map((row, index) => {
          const indice = index;
          return (
            <TableCell
              key={indice}
              align={row.align || 'left'}
              padding="default"
              sortDirection={orderBy === row.name ? order : false}
              style={{ width: row.width ? row.width : '' }}
            >
              <TableSortLabel
                active={orderBy === row.name}
                direction={orderBy === row.name ? order : 'asc'}
                onClick={() => setOrderBy(row.name)}
              >
                {row.label}
                {orderBy === row.name ? (
                  <span style={styles.visuallyHidden}>
                    {order === 'desc' ? 'ordenar descendientemente' : 'ordenar ascendentemente'}
                  </span>
                ) : null}
              </TableSortLabel>

            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}

Header.propTypes = {
  columns: PropTypes.oneOfType([PropTypes.array]).isRequired,
  orderBy: PropTypes.string,
  order: PropTypes.string,
  setOrderBy: PropTypes.func,
  onRowsSelect: PropTypes.func,
  extraColumn: PropTypes.bool,
  onCheckedAll: PropTypes.func,
  checkedAll: PropTypes.bool,
  selectableCondition: PropTypes.func,
  data: PropTypes.oneOfType([PropTypes.array]),
};

export default Header;
